import { render, staticRenderFns } from "./PublicDisplayQuestion.vue?vue&type=template&id=cbc931ee&scoped=true"
import script from "./PublicDisplayQuestion.vue?vue&type=script&lang=js"
export * from "./PublicDisplayQuestion.vue?vue&type=script&lang=js"
import style0 from "./PublicDisplayQuestion.vue?vue&type=style&index=0&id=cbc931ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc931ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbc931ee')) {
      api.createRecord('cbc931ee', component.options)
    } else {
      api.reload('cbc931ee', component.options)
    }
    module.hot.accept("./PublicDisplayQuestion.vue?vue&type=template&id=cbc931ee&scoped=true", function () {
      api.rerender('cbc931ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/PublicDisplayQuestion.vue"
export default component.exports